import { render } from "./Colombia.vue?vue&type=template&id=31b06d31&scoped=true&ts=true"
import script from "./Colombia.vue?vue&type=script&lang=ts"
export * from "./Colombia.vue?vue&type=script&lang=ts"

import "./Colombia.vue?vue&type=style&index=0&id=31b06d31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b06d31"]])

export default __exports__